export default "__VITE_ASSET__DAzkSAnI__"